type SportColorKey = "primary" | "amber" | "blue" | "violet" | "pink";

export interface SportColorClasses {
  bg: string;
  bgHover: string;
  bgActive: string;
  border: string;
  text: string;
  badgeBg: string;
  badgeText: string;
  dot: string;
}

const SPORT_NAME_TO_COLOR: Record<string, SportColorKey> = {
  TENNIS: "primary",
  PADEL: "amber",
  BASKETBALL: "blue",
  FOOTBALL: "violet",
  VOLLEYBALL: "pink",
};

const PALETTE_ORDER: SportColorKey[] = [
  "primary",
  "amber",
  "blue",
  "violet",
  "pink",
];

const CLASSES: Record<SportColorKey, SportColorClasses> = {
  primary: {
    bg: "bg-primary-50",
    bgHover: "hover:bg-primary-100",
    bgActive: "active:bg-primary-100",
    border: "border-primary-500",
    text: "text-primary-700",
    badgeBg: "bg-primary-600",
    badgeText: "text-white",
    dot: "bg-primary-500",
  },
  amber: {
    bg: "bg-sport-amber-50",
    bgHover: "hover:bg-sport-amber-100",
    bgActive: "active:bg-sport-amber-100",
    border: "border-sport-amber-500",
    text: "text-sport-amber-700",
    badgeBg: "bg-sport-amber-600",
    badgeText: "text-white",
    dot: "bg-sport-amber-500",
  },
  blue: {
    bg: "bg-sport-blue-50",
    bgHover: "hover:bg-sport-blue-100",
    bgActive: "active:bg-sport-blue-100",
    border: "border-sport-blue-500",
    text: "text-sport-blue-700",
    badgeBg: "bg-sport-blue-600",
    badgeText: "text-white",
    dot: "bg-sport-blue-500",
  },
  violet: {
    bg: "bg-sport-violet-50",
    bgHover: "hover:bg-sport-violet-100",
    bgActive: "active:bg-sport-violet-100",
    border: "border-sport-violet-500",
    text: "text-sport-violet-700",
    badgeBg: "bg-sport-violet-600",
    badgeText: "text-white",
    dot: "bg-sport-violet-500",
  },
  pink: {
    bg: "bg-sport-pink-50",
    bgHover: "hover:bg-sport-pink-100",
    bgActive: "active:bg-sport-pink-100",
    border: "border-sport-pink-500",
    text: "text-sport-pink-700",
    badgeBg: "bg-sport-pink-600",
    badgeText: "text-white",
    dot: "bg-sport-pink-500",
  },
};

interface SportLike {
  id: string;
  name: string;
}

function colorKeyForSport(
  sportId: string,
  sportsInScope: SportLike[],
): SportColorKey {
  if (sportsInScope.length <= 1) return "primary";
  const sport = sportsInScope.find((s) => s.id === sportId);
  if (!sport) return "primary";
  const mapped = SPORT_NAME_TO_COLOR[sport.name.toUpperCase()];
  if (mapped) return mapped;
  // Fallback: assign palette by stable position so unknown sport names still
  // get distinct colors instead of all collapsing to primary.
  const idx = sportsInScope.findIndex((s) => s.id === sportId);
  return PALETTE_ORDER[Math.max(0, idx) % PALETTE_ORDER.length];
}

export function colorForSport(
  sportId: string,
  sportsInScope: SportLike[],
): SportColorClasses {
  return CLASSES[colorKeyForSport(sportId, sportsInScope)];
}
